/**
 * Type predicate to check if an error has a response.data.message property
 * This is useful for handling API errors that come from axios
 */
export function hasErrorMessage(error: unknown): error is {
  response: {
    data: {
      message: string
    }
  }
} {
  return (
    typeof error === "object" &&
    error !== null &&
    "response" in error &&
    typeof error.response === "object" &&
    error.response !== null &&
    "data" in error.response &&
    typeof error.response.data === "object" &&
    error.response.data !== null &&
    "message" in error.response.data &&
    typeof error.response.data.message === "string"
  );
}

/**
 * Extracts the error message from an API error response
 * @param error The error object
 * @param defaultMessage Default message to display if the error message cannot be extracted
 * @returns A formatted error message
 */
export function getErrorMessage(error: unknown, defaultMessage = "An error occurred"): string {
  if (hasErrorMessage(error)) {
    return error.response.data.message;
  }

  // Handle other error types
  if (error instanceof Error) {
    return error.message;
  }

  return defaultMessage;
}
